import { render, staticRenderFns } from "./Doughnut.vue?vue&type=template&id=cf9e45b0"
import script from "./Doughnut.vue?vue&type=script&lang=js"
export * from "./Doughnut.vue?vue&type=script&lang=js"
import style0 from "./Doughnut.vue?vue&type=style&index=0&id=cf9e45b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports